<template>
  <DBox
    :id="'cmp-distribution-order-sidewindow-summary'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="'Add a Contact'"
    :backgroundColor="'#F7FFF2'"
  >
    <div class="ut-flex" style="padding: 10px; align-items: flex-start">
      <InvoiceContactSummary
        style="flex: 1; min-height: 190px"
        :contact="selectedOrder.contact"
      />
      <DeliveryAddressSummary
        style="flex: 1; min-height: 190px !important; margin-left: 5px"
        :order="
          selectedOrder &&
          selectedOrder.order_details_tab_summary &&
          selectedOrder.order_details_tab_summary.order
        "
      />
      <div class="ut-fc" style="margin-right: 10px; flex: 1.66">
        <div class="ut-flex ut-jend">
          <OrderKVSummary :selectedOrder="selectedOrder" />
        </div>
        <div class="ut-flex ut-jend ut-text-secondary">
          <DTCheckbox
            :id="'ready_to_ship'"
            :label="$t('ready_to_ship')"
            :checked="
              isChecked(
                selectedOrder &&
                  selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order['ready_to_ship']
              )
            "
            :h="'24px'"
            :minH="'24px'"
            :class="'ml0'"
            :style="'margin-right: 0px'"
            @click="(e) => onShipClick(e.target.checked)"
          />
        </div>
        <div
          class="ut-flex ut-jend"
          style="margin-left: 10px; margin-top: 30px; width: 100%"
          :class="{
            'dt-loading': selectedOrder.order_details_tab_summary_loading,
          }"
        >
          <!-- <button
            @click="onDocumentClick"
            class="dt-button v5 s8"
            style="margin-right: 0px"
          >
            {{ $t("documents") }}
          </button> -->
          <button
            v-if="selectedOrder.invoiced"
            disabled
            class="disabled dt-button v5 s8"
            style="margin-right: 0px"
          >
            {{ $t("shipping_invoiced") }}
          </button>
          <button
            v-if="selectedOrder.shippingAccounted"
            disabled
            class="disabled dt-button v5 s8"
            style="margin-right: 0px"
          >
            {{ $t("shipping_accounted") }}
          </button>
          <button
            v-if="selectedOrder.hasInvoice"
            @click="onOpenRelatedInvoice"
            class="dt-button v5 s8"
            style="margin-right: 0px"
          >
            {{ $t("open_related_invoice") }}
          </button>
          <button
            v-if="selectedOrder.shippingAccountable"
            @click="onAccountShipping"
            class="dt-button v5 s8"
            style="margin-right: 0px"
          >
            {{ $t("account_shipping") }}
          </button>
          <button
            v-if="selectedOrder.isAccounted"
            @click="onReopenClicked"
            class="dt-button v5 s8"
          >
            {{ $t("reopen") }}
          </button>
          <button
            v-if="!selectedOrder.isAccounted"
            @click="onAccountClick"
            class="dt-button v5 s8"
          >
            {{ $t("account") }}
          </button>
        </div>
      </div>
    </div>
    <div style="padding: 10px; background-color: #f7fff2">
      <OrderLineTable @shipClick="onShipClick" :selectedOrder="selectedOrder" />

      <div class="ut-flex">
        <DeliveryInfoSummary
          @changed="onChange"
          style="flex: 0.5; margin-top: 20px; max-width: 50%"
          :order="
            selectedOrder &&
            selectedOrder.order_details_tab_summary &&
            selectedOrder.order_details_tab_summary.order
          "
        />
      </div>
    </div>
  </DBox>
</template>

<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import { onDetailsRowClicked, routeWithFrom } from "../../../../utility/route";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import InvoiceContactSummary from "./invoice-contact-summary.vue";
import DeliveryAddressSummary from "./delivery-address-summary.vue";
import DeliveryInfoSummary from "./delivery-info-summary.vue";
import OrderLineTable from "./order-line-table-summary.vue";
import OrderKVSummary from "./order-kv-summary.vue";

import { isChecked } from "../../../../utility";
import { OrderService } from "../../services/order.service";
import { showError } from "../../../../dt-plugins/notification/notification.service";
import { confirmError } from "../../../../dt-plugins/confirmation/confirmation-common";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { openModalRoute2 } from "../../../../dt-plugins/modal/modal.mixin";
export default {
  props: {
    selectedOrder: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    InvoiceContactSummary,
    DeliveryAddressSummary,
    DeliveryInfoSummary,
    OrderLineTable,
    OrderKVSummary,
  },

  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        headerHeight: 32,
        fullHeight: true,
      }),
    };
  },
  computed: {
    order_id:function(){
      return  this.$route.params.order_id
    },
    Headers: function () {
      return [
        createTableHeader("type", {}),
        createTableHeader("units", { ta: "right" }),
        createTableHeader("amounts", { ta: "right" }),
      ];
    },
  },
  methods: {
    isChecked: isChecked,
    onChange: function (payload) {
      console.log("onChange", payload);
      this.$emit("changed", payload);
    },

    onShipClick: function (value) {
      this.$emit("changed", { name: "ready_to_ship", value: value ? 1 : 0 });
    },
    // onDocumentClick: function () {
    //   this.$router.push({
    //     ...this.$route,
    //     query: {
    //       modal: "documents_modal",
    //       order_id: this.order_id,
    //     },
    //   });
    // },
    // onNotifyClick: async function () {
    //   NotificationService.showNotification({
    //     text: "Sending Request ...",
    //     timeout: 2000,
    //     type: "normal",
    //   });
    //   const resData = await OrderService.shippingNotify(
    //     this.order_id,
    //     0,
    //     "DHL"
    //   );
    // },
    onAccountClick: async function () {
      if (
        this.selectedOrder?.order_details_tab_summary?.orderlines?.length == 0
      ) {
        showError(this.$t("no_order_account"));
        return;
      }

      const isOK = await OrderService.checkContraAccountId(this.order_id);

      const orderlineWithoutPriceCount =
        await OrderService.orderlines_without_price(
          this.$route.params.order_id
        ).then((res) => res.data.count);

      let check_prices = false,
        confirmationResult = null;

      if (orderlineWithoutPriceCount > 0) {
        confirmationResult = await ConfirmationService.createP({
          subject: `Orderlines without price`,
          body: `${orderlineWithoutPriceCount} ${this.$t(
            "orderlines_without_price"
          )}`,
          model: true,
          width: 500,
          results: [
            createConfirmResult({
              text: this.$t("check_prices"),
              value: "check_prices",
              classes: ["s6"],
            }),
            createConfirmResult({
              text: this.$t("proceed_without_prices"),
              value: "proceed_without_prices",
              classes: ["v1 s6"],
            }),
          ],
          // completed: (res) => {
          //   console.log("res", res);
          //   switch (res) {
          //     case "proceed_without_prices": {
          //       break;
          //     }isOK
          //     case "check_prices": {
          //       check_prices = true;
          //       console.log("check_prices", check_prices);
          //       break;
          //     }
          //     default: {
          //       check_prices = true;
          //       console.log("default cp", check_prices);
          //       break;
          //     }
          //   }
          // },
        });

        switch (confirmationResult) {
          case "proceed_without_prices": {
            break;
          }
          case "check_prices": {
            check_prices = true;
            // console.log("check_prices", check_prices);
            break;
          }
          default: {
            check_prices = true;
            // console.log("default cp", check_prices);
            break;
          }
        }

        // console.log("If check_prices", check_prices);
        if (check_prices) {
          return;
        }
      }

      if (isOK.data.is_ok == 1) {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "account_date_modal",
            order_id: this.order_id,
          },
        });
      } else {
        ConfirmationService.create({
          subject: `Select Stock Account`,
          model: true,
          width: 500,
          completed: (res) => {
            switch (res) {
              case "OK": {
                break;
              }
            }
          },
        });
      }

      console.log(orderlineWithoutPriceCount, isOK, "count,isOK");
    },
    onReopenClicked() {
      this.$emit("reopen", true);
    },
    onOpenRelatedInvoice() {
      routeWithFrom(this, {
        name: `invoices/invoice_id/tab`,
        params: {
          invoice_id:
            this.selectedOrder?.order_details_tab_summary?.invoice?.invoice_id,
          tab: "overview",
        },
      });
    },
    onAccountShipping() {
      openModalRoute2(this, "accountShippingCosts");

      // routeWithFrom(this, {
      //   name: `invoices/invoice_id/tab`,
      //   params: {
      //     invoice_id:
      //       this.selectedOrder?.order_details_tab_summary?.invoice?.invoice_id,
      //     tab: "overview",
      //   },
      // });
    },

    //MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-distribution-order-sidewindow-summary {
  .dt-ntable {
    background-color: #f7fff2;
    thead {
      tr:nth-child(1) {
        th {
          span {
            margin: 0px;
          }
        }
      }
    }
    tbody {
      tr {
        td:nth-child(1) {
          span {
            margin: 0px;
          }
        }
      }
      tr:nth-child(5) {
        td {
          border-right: 0px !important;
        }
      }
      tr:nth-child(8) {
        td {
          border-right: 0px !important;
        }
      }
    }
  }
}
</style>